<script setup lang="ts">
const props = defineProps({
  url: {
    type: String,
  },
  printableUrl: {
    type: String,
  },
})

const url = computed(() => props.url ?? `${useSiteConfig().url}${useRoute().fullPath}` )

const shareLinks = useShareLinks({ url: url.value, utm: { source: 'auto', campaign: 'page_share' } })

function copyLink() {
  const u = new URL(url.value)

  u.searchParams.append('utm_source', 'sharelink')
  u.searchParams.append('utm_campaign', 'page_share')

  useClipboard({ source:  u.toString() }).copy()
  useToast().add({
    title: 'Le lien a été copié dans votre Presse-papiers',
    icon: 'i-ph-check-circle-duotone',
  })
}

</script>

<template>
  <div class="flex gap-2 justify-center mt-4">
    <UButton icon="i-ri-facebook-fill" :to="shareLinks.facebook" target="_blank" rel="nofollow noopener noreferrer" color="neutral" class="rounded-full bg-[#165dee]" />
    <UButton icon="i-ri-linkedin-fill" :to="shareLinks.linkedin" target="_blank" rel="nofollow noopener noreferrer" color="neutral" class="rounded-full bg-[#007bb6]" />
    <UButton icon="i-ph-envelope-duotone" :to="shareLinks.email" target="_blank" rel="nofollow noopener noreferrer" color="primary" class="rounded-full" />
    <UButton icon="i-ph-link-simple" @click="copyLink()" color="primary" class="rounded-full" />
    <UButton v-if="printableUrl" icon="i-ph-printer-duotone" :to="printableUrl" target="_blank" rel="nofollow noopener noreferrer" color="primary" class="rounded-full" />
  </div>
</template>